import { combineReducers } from 'redux';
import sites from './sites.reducers';
import site from './site.reducers';

const reducer = combineReducers({
    sites, site
});

export default reducer;
